import React from 'react';
import {useDispatch} from 'react-redux';
import {setTutorChatOpen} from 'store/lessonContentViewer/actions';

const HELP_BUTTON_ENABLED_PHASES = new Set([
  'learning',
  'workbook_ready',
  'workbook_exercise',
  'workbook_options',
  'knowledge_check',
]);

const LCVHelpButton = ({phase, className}) => {
  const dispatch = useDispatch();

  if (!HELP_BUTTON_ENABLED_PHASES.has(phase)) return null;

  const handleClick = () => {
    dispatch(setTutorChatOpen(true));
  };

  return (
    <button
      type="button"
      className={['lcv-help-btn', className].filter(Boolean).join(' ')}
      onClick={handleClick}
      title="Get help from your tutor"
      aria-label="Open tutor chat"
    >
      <span className="lcv-help-btn-icon" aria-hidden="true">
        💡
      </span>
      <span className="lcv-help-btn-label">Need help?</span>
    </button>
  );
};

export default LCVHelpButton;
